import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux/store';
import { PlayerVehicles } from './views/PlayerVehicles';

const LayoutComponent = () => (
	<Provider store={store}>
		<Background />
		<PlayerVehicles />
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.PlayerVehicles)
	.setHudVisible(true)
	.build();

export default Layout;
